<template>
  <AppDialogContent
    v-model="dialog"
    :error="formError"
    :persistent="loading"
    :loading="loading"
    @submit-form="submit()"
  >
    <template #header>
      {{ $t("events:EventPage.Schedule.SplitClassModal.heading") }}
    </template>
    <p>
      {{ $t("events:EventPage.Schedule.SplitClassModal.explainer") }}
      <br />
      {{ $t("events:EventPage.Schedule.SplitClassModal.PleaseNote.text") }}
    </p>
    <ul>
      <li>
        {{
          $t("events:EventPage.Schedule.SplitClassModal.PleaseNote.point1.text")
        }}
      </li>

      <li>
        {{
          $t("events:EventPage.Schedule.SplitClassModal.PleaseNote.point2.text")
        }}
      </li>

      <li>
        {{
          $t("events:EventPage.Schedule.SplitClassModal.PleaseNote.point3.text")
        }}
      </li>
    </ul>
    <br />
    <v-row class="mb-2">
      <v-col cols="6" class="pb-0">
        {{
          $t("events:EventPage.Schedule.SplitClassModal.1stClassCode.heading")
        }}
      </v-col>
      <v-col cols="6" class="pb-0">
        {{
          $t("events:EventPage.Schedule.SplitClassModal.2ndClassCode.heading")
        }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="firstCompetitionCode"
          variant="outlined"
          :label="
            $t('events:EventPage.Schedule.SplitClassModal.1stClassCode.label')
          "
          :hint="
            $t('events:EventPage.Schedule.SplitClassModal.1stClassCode.hint')
          "
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="secondCompetitionCode"
          variant="outlined"
          :label="
            $t('events:EventPage.Schedule.SplitClassModal.2ndClassCode.label')
          "
          :hint="
            $t('events:EventPage.Schedule.SplitClassModal.2ndClassCode.hint')
          "
        />
      </v-col>
    </v-row>
  </AppDialogContent>
</template>
<script>
import gql from "fraql";
import AppDialogContent from "@/components/elements/AppDialogContent.vue";

export default {
  name: "SplitCompetitionForm",
  components: { AppDialogContent },
  props: {
    refetchQueries: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      modelValue: false,
      loading: false,
      formError: {},
      // id is set by parent
      competitionId: null,
      // competition code is set by parent
      firstCompetitionCode: null,
      secondCompetitionCode: null
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.modelValue = val;
      }
    }
  },
  methods: {
    openForm(item) {
      this.loading = false;
      this.formError = {};

      this.competitionId = item.id;
      this.firstCompetitionCode = item.code;
      this.secondCompetitionCode = null;
      this.dialog = true;
    },
    async submit() {
      this.formError = {};
      if (this.firstCompetitionCode == this.secondCompetitionCode) {
        this.formError = {
          "": ["Class codes must be unique"]
        };
        return;
      } else {
        if (!this.firstCompetitionCode || !this.secondCompetitionCode) {
          this.formError = {
            "": ["Both classes must have codes"]
          };
          return;
        }
      }
      this.loading = true;
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation eventCompetitionSplit(
              $id: ID!
              $firstCompetitionCode: String!
              $secondCompetitionCode: String!
            ) {
              eventCompetitionSplit(
                input: {
                  id: $id
                  firstCompetitionCode: $firstCompetitionCode
                  secondCompetitionCode: $secondCompetitionCode
                }
              ) {
                competition {
                  id
                  name
                  eventId
                  description
                  code
                  startDate
                  eventcodeId
                  eventcodeComplement
                  difficultyLevelId
                  competitionRuleId
                  competitionLevelId
                  cupSeasons {
                    id
                    nameShort
                    name
                    infoLink
                  }
                  dressageArenaSize
                  dressageArenaGround
                  marathonArenaSize
                  marathonArenaGround
                  marathonArenaHasWater
                  marathonNumberOfObstacles
                  conesArenaSize
                  conesArenaGround
                  conesClearance
                  conesJudgement

                  registrationFeeToFederationCents
                  registrationFeeToRegionalCents
                  startingFeeToFederationCents
                  startingFeeToRegionalCents

                  useDiscountedRegistrationFeeForClubMembers
                  useDiscountedStartingFeeForClubMembers
                  startingFeeToOrganiserCents
                  registrationFeeToOrganiserCents
                  discountedRegistrationFeeCents
                  discountedStartingFeeCents
                  lateRegistrationFee
                  lateRegistrationFeeCents
                  registrationFeeToFederationCents
                  cupFeeToFederation
                  cupFeeToFederationCents
                  prizePoolCents
                  prizeDistribution
                  prizeText
                  sectionIds
                  registrationsCount

                  allowedMutations
                }
              }
            }
          `,
          refetchQueries: this.refetchQueries || ["event"],
          variables: {
            id: this.competitionId,
            firstCompetitionCode: this.firstCompetitionCode,
            secondCompetitionCode: this.secondCompetitionCode
          }
        });
        this.dialog = false;
      } catch (error) {
        if (process.env.NODE_ENV === "development") console.error(error);
        this.$root.$snackbarServerError(error, { level: "error" });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
